import { useEffect, useState, ReactNode } from 'react'

interface PageTransitionProps {
  children: ReactNode
  locationKey: string
}

export function PageTransition({ children, locationKey }: PageTransitionProps) {
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    setAnimating(true)
    const timeout = setTimeout(() => setAnimating(false), 300)
    return () => clearTimeout(timeout)
  }, [locationKey])

  return (
    <div
      className={`flex flex-1 flex-col min-h-0 transition-all duration-300 ease-out ${
        animating
          ? 'opacity-0 translate-y-2 blur-[2px]'
          : 'opacity-100 translate-y-0 blur-0'
      }`}
    >
      {children}
    </div>
  )
}
